module.exports = __webpack_public_path__ + "img/sankaku_83_red.a87b3837.png";